import Button from '@vromo/ui/components/Button';
import Modal, { ModalActions, ModalContent, ModalHeader } from '@vromo/ui/components/Modal';
import Title from '@vromo/ui/components/Title';
import { observer } from 'mobx-react-lite';
import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { JobHistoryResponse } from '../../helpers/JobHistoryHelper';
import styles from './auditHistoryModal.style';
import AuditHistoryItem from './components/AuditHistoryItem/AuditHistoryItem';

interface Props {
    isOpen: boolean;
    selectedJob?: JobHistoryResponse;
    onClose: () => void;
}

const AuditHistoryModal = observer<Props>(({ isOpen, selectedJob, onClose }) => {
    const { t } = useTranslation();
    const translate = (key: string, params?: any) => t(`jobHistory.${key}`, params);

    const { name, id } = selectedJob || {};

    return (
        <Modal isOpen={isOpen} onRequestClose={onClose}>
            <ModalHeader>
                <Title>{translate('auditHistory')}</Title>
                {!!name && (
                    <div className={styles.jobName}>
                        {`${t('job.jobName')}: `}
                        <b>{name}</b>
                    </div>
                )}
                {!!id && (
                    <div className={styles.jobId}>
                        {`${translate('jobId')}: `}
                        <b>{id}</b>
                    </div>
                )}
            </ModalHeader>
            <ModalContent>
                {selectedJob?.dispatches?.length ? (
                    selectedJob?.dispatches.map((dispatch) => (
                        <AuditHistoryItem key={dispatch.id} {...{ dispatch }} />
                    ))
                ) : (
                    <div className={styles.emptyContainer}>{translate('noAudit')}</div>
                )}
            </ModalContent>
            <ModalActions>
                <Button onClick={onClose}>{translate('close')}</Button>
            </ModalActions>
        </Modal>
    );
});

export default memo(AuditHistoryModal);
